<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
            :before-close="beforeDialogClose"
    >
        <loading v-if="!isInitialized"></loading>
        <contact-list-form
                ref="form"
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></contact-list-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import ContactListForm from '../../components/contact-list/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      ContactListForm
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Contact List'
        }

        return 'Create Contact List'
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-contact-list-list');
      },

      /**
       * @param {function} $done
       */
      beforeDialogClose($done) {
        !this.$refs.form.isFormBusy() && $done();
      },
    },

    created() {
      eventBus.$on('show-add-contact-list-dialog', this.show);
      eventBus.$on('show-edit-contact-list-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-contact-list-dialog', this.show);
      eventBus.$off('show-edit-contact-list-dialog', this.show);
    }
  }
</script>
